var _style, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGitHubLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#221E1B;}\n\t.st1{fill:#221E1B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.5,2C22.7,2,0.2,24.5,0.2,52.2c0,22.2,14.4,41,34.4,47.7c2.5,0.5,3.4-1.1,3.4-2.4c0-1.2,0-5.2-0.1-9.4 c-14,3-16.9-5.9-16.9-5.9c-2.3-5.8-5.6-7.4-5.6-7.4c-4.6-3.1,0.3-3.1,0.3-3.1c5,0.4,7.7,5.2,7.7,5.2c4.5,7.7,11.8,5.5,14.6,4.2 c0.5-3.2,1.8-5.5,3.2-6.7c-11.2-1.3-22.9-5.6-22.9-24.8c0-5.5,2-10,5.2-13.5c-0.5-1.3-2.2-6.4,0.5-13.3c0,0,4.2-1.3,13.8,5.2 c4-1.1,8.3-1.7,12.6-1.7c4.3,0,8.6,0.6,12.6,1.7c9.6-6.5,13.8-5.2,13.8-5.2c2.7,6.9,1,12,0.5,13.3c3.2,3.5,5.2,8,5.2,13.5 c0,19.3-11.8,23.6-22.9,24.8C61.4,76,63,79,63,83.7c0,6.7-0.1,12.1-0.1,13.8c0,1.3,0.9,2.9,3.5,2.4c20-6.7,34.3-25.5,34.3-47.7 C100.7,24.5,78.2,2,50.5,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.3,74.1c-0.1,0.3-0.5,0.3-0.9,0.2c-0.4-0.2-0.6-0.5-0.5-0.8c0.1-0.3,0.5-0.3,0.9-0.2 C19.2,73.5,19.4,73.9,19.3,74.1L19.3,74.1z M18.6,73.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.3,76.4c-0.2,0.2-0.7,0.1-1-0.2c-0.3-0.4-0.4-0.8-0.1-1c0.2-0.2,0.7-0.1,1,0.2 C21.5,75.7,21.5,76.2,21.3,76.4L21.3,76.4z M20.8,75.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.3,79.3c-0.3,0.2-0.8,0-1.1-0.4c-0.3-0.4-0.3-1,0-1.2c0.3-0.2,0.8,0,1.1,0.4C23.6,78.5,23.6,79.1,23.3,79.3 L23.3,79.3z M23.3,79.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26,82.1c-0.3,0.3-0.9,0.2-1.3-0.2c-0.4-0.4-0.6-1-0.3-1.3c0.3-0.3,0.9-0.2,1.3,0.2 C26.2,81.2,26.3,81.8,26,82.1L26,82.1z M26,82.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.7,83.7c-0.1,0.4-0.7,0.6-1.3,0.4c-0.6-0.2-0.9-0.6-0.8-1c0.1-0.4,0.7-0.6,1.3-0.4 C29.5,82.9,29.9,83.3,29.7,83.7L29.7,83.7z M29.7,83.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.8,84c0,0.4-0.5,0.8-1.1,0.8c-0.6,0-1.1-0.3-1.1-0.7c0-0.4,0.5-0.8,1.1-0.8C33.4,83.3,33.8,83.6,33.8,84 L33.8,84z M33.8,84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.7,83.4c0.1,0.4-0.3,0.8-0.9,0.9c-0.6,0.1-1.1-0.1-1.2-0.5c-0.1-0.4,0.4-0.8,0.9-0.9 C37.1,82.7,37.6,83,37.7,83.4L37.7,83.4z M37.7,83.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitHubLogo);
export default __webpack_public_path__ + "static/media/gitHubLogo.c4fae0e5aac04de9df0ee80c21b001f7.svg";
export { ForwardRef as ReactComponent };